import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, unref as _unref, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, Transition as _Transition, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7e67b94a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "min-h-screen bg-gray-950 halloween-page" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"floating-decorations pointer-events-none fixed inset-0 overflow-hidden z-0\" data-v-7e67b94a><div class=\"ghost ghost-1\" data-v-7e67b94a>👻</div><div class=\"ghost ghost-2\" data-v-7e67b94a>👻</div><div class=\"ghost ghost-3\" data-v-7e67b94a>👻</div><div class=\"bat bat-1\" data-v-7e67b94a>🦇</div><div class=\"bat bat-2\" data-v-7e67b94a>🦇</div><div class=\"bat bat-3\" data-v-7e67b94a>🦇</div><div class=\"pumpkin pumpkin-1\" data-v-7e67b94a>🎃</div><div class=\"pumpkin pumpkin-2\" data-v-7e67b94a>🎃</div><div class=\"spider spider-1\" data-v-7e67b94a>🕷</div></div>", 1)
const _hoisted_3 = { class: "relative z-10 bg-gradient-to-b from-purple-900 via-gray-900 to-gray-950 text-white py-12 border-b-4 border-orange-500" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "absolute inset-0 overflow-hidden opacity-30" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "stars" })
], -1))
const _hoisted_5 = { class: "container mx-auto px-4 max-w-6xl relative" }
const _hoisted_6 = { class: "text-center" }
const _hoisted_7 = { class: "text-4xl md:text-6xl font-bold mb-4 text-orange-400 drop-shadow-[0_0_10px_rgba(251,146,60,0.5)] spooky-title" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-lg text-purple-200 mb-4 max-w-2xl mx-auto" }, [
  /*#__PURE__*/_createTextVNode(" Join us for trick-or-treating in the neighborhood! Competing for "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-orange-300 font-medium" }, "Best Decorated"),
  /*#__PURE__*/_createTextVNode(" or "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-purple-300 font-medium" }, "Best Photo Op"),
  /*#__PURE__*/_createTextVNode("? Register below to enter the contest. ")
], -1))
const _hoisted_9 = {
  key: 0,
  class: "flex flex-wrap justify-center gap-4 text-lg"
}
const _hoisted_10 = { class: "flex items-center gap-2" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "h-5 w-5",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
  })
], -1))
const _hoisted_12 = { class: "flex items-center gap-2" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "h-5 w-5",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
  })
], -1))
const _hoisted_14 = {
  key: 1,
  class: "mt-8 flex justify-center gap-8 md:gap-16"
}
const _hoisted_15 = { class: "text-center" }
const _hoisted_16 = { class: "text-3xl font-bold" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-purple-300 text-sm" }, "Haunted Houses", -1))
const _hoisted_18 = { class: "text-center" }
const _hoisted_19 = { class: "text-3xl font-bold text-green-400" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-purple-300 text-sm" }, "Spirits Summoned", -1))
const _hoisted_21 = { class: "mt-8 space-y-3" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-2xl" }, "🏆", -1))
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" Enter the Contest ")
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-2xl" }, "🏆", -1))
const _hoisted_25 = [
  _hoisted_22,
  _hoisted_23,
  _hoisted_24
]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-purple-300/70" }, " Contest registration is optional — all houses welcome for trick-or-treating! ", -1))
const _hoisted_27 = { class: "container mx-auto px-4 py-8 max-w-6xl relative z-10" }
const _hoisted_28 = { class: "bg-gray-900 rounded-xl border border-purple-800 shadow-lg shadow-purple-900/20 mb-6" }
const _hoisted_29 = { class: "flex" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-lg" }, "🗺", -1))
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" Spooky Map ")
const _hoisted_32 = {
  key: 0,
  class: "absolute bottom-0 left-0 right-0 h-0.5 bg-orange-500"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-lg" }, "🏆", -1))
const _hoisted_34 = /*#__PURE__*/_createTextVNode(" Leaderboard ")
const _hoisted_35 = {
  key: 0,
  class: "absolute bottom-0 left-0 right-0 h-0.5 bg-green-500"
}
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-lg" }, "🏆", -1))
const _hoisted_37 = /*#__PURE__*/_createTextVNode(" Enter Contest ")
const _hoisted_38 = {
  key: 0,
  class: "absolute bottom-0 left-0 right-0 h-0.5 bg-purple-500"
}
const _hoisted_39 = { key: 0 }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 mb-4 text-sm" }, " These houses are competing in our decoration contests. Vote for your favorites! ", -1))
const _hoisted_41 = { class: "mb-6 flex flex-wrap gap-2" }
const _hoisted_42 = {
  key: 0,
  class: "text-center py-12"
}
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-5xl animate-bounce" }, "👻", -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-2 text-gray-400" }, "Summoning spirits...", -1))
const _hoisted_45 = [
  _hoisted_43,
  _hoisted_44
]
const _hoisted_46 = {
  key: 1,
  class: "text-center py-12 bg-gray-900 rounded-xl border border-gray-800"
}
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-6xl mb-4" }, "🏪", -1))
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "mt-4 text-lg font-medium text-gray-200" }, " No contest entries yet... ", -1))
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-2 text-gray-400" }, " Be the first to enter the decoration contest! ", -1))
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "🏆", -1))
const _hoisted_51 = /*#__PURE__*/_createTextVNode(" Enter Contest ")
const _hoisted_52 = [
  _hoisted_50,
  _hoisted_51
]
const _hoisted_53 = {
  key: 2,
  class: "grid gap-6 md:grid-cols-2 lg:grid-cols-3"
}
const _hoisted_54 = { class: "aspect-video bg-gray-800 relative" }
const _hoisted_55 = ["src", "alt"]
const _hoisted_56 = {
  key: 1,
  class: "w-full h-full flex items-center justify-center text-gray-600"
}
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-6xl" }, "🏪", -1))
const _hoisted_58 = [
  _hoisted_57
]
const _hoisted_59 = { class: "absolute top-2 right-2 flex gap-1" }
const _hoisted_60 = {
  key: 0,
  class: "px-2 py-1 rounded-full bg-orange-500/90 backdrop-blur text-white text-xs font-medium"
}
const _hoisted_61 = {
  key: 1,
  class: "px-2 py-1 rounded-full bg-purple-500/90 backdrop-blur text-white text-xs font-medium"
}
const _hoisted_62 = { class: "p-4" }
const _hoisted_63 = { class: "font-semibold text-lg text-orange-400" }
const _hoisted_64 = {
  key: 0,
  class: "text-sm text-gray-400"
}
const _hoisted_65 = {
  key: 1,
  class: "mt-4 flex flex-col sm:flex-row gap-2"
}
const _hoisted_66 = ["onClick", "disabled"]
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-lg" }, "🎃", -1))
const _hoisted_68 = /*#__PURE__*/_createTextVNode(" Vote Decorated ")
const _hoisted_69 = [
  _hoisted_67,
  _hoisted_68
]
const _hoisted_70 = ["onClick", "disabled"]
const _hoisted_71 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-lg" }, "📷", -1))
const _hoisted_72 = /*#__PURE__*/_createTextVNode(" Vote Photo Op ")
const _hoisted_73 = [
  _hoisted_71,
  _hoisted_72
]
const _hoisted_74 = {
  key: 2,
  class: "mt-4 text-center text-sm text-gray-400"
}
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-lg" }, "🕒", -1))
const _hoisted_76 = { key: 1 }
const _hoisted_77 = {
  key: 0,
  class: "text-center py-12"
}
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-5xl animate-bounce" }, "🏆", -1))
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-2 text-gray-400" }, "Counting the spirits...", -1))
const _hoisted_80 = [
  _hoisted_78,
  _hoisted_79
]
const _hoisted_81 = {
  key: 1,
  class: "grid gap-6 md:grid-cols-2"
}
const _hoisted_82 = { class: "bg-gray-900 rounded-xl border border-orange-800/50 shadow-lg shadow-orange-900/20 overflow-hidden" }
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "px-6 py-4 border-b border-orange-800/50 bg-gradient-to-r from-orange-900/50 to-gray-900" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "text-lg font-heading font-semibold text-orange-400 flex items-center gap-2" }, [
    /*#__PURE__*/_createElementVNode("span", null, "🎃"),
    /*#__PURE__*/_createTextVNode(" Best Decorated House ")
  ])
], -1))
const _hoisted_84 = { class: "divide-y divide-gray-800" }
const _hoisted_85 = { key: 0 }
const _hoisted_86 = { key: 1 }
const _hoisted_87 = { class: "flex-1 min-w-0" }
const _hoisted_88 = { class: "font-medium text-orange-300 truncate" }
const _hoisted_89 = { class: "text-sm text-gray-500 truncate" }
const _hoisted_90 = { class: "text-right" }
const _hoisted_91 = { class: "font-semibold text-orange-400" }
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-gray-500 ml-1" }, "votes", -1))
const _hoisted_93 = {
  key: 0,
  class: "px-6 py-8 text-center text-gray-500"
}
const _hoisted_94 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-3xl" }, "👻", -1))
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-2" }, "No spirits summoned yet...", -1))
const _hoisted_96 = [
  _hoisted_94,
  _hoisted_95
]
const _hoisted_97 = { class: "bg-gray-900 rounded-xl border border-purple-800/50 shadow-lg shadow-purple-900/20 overflow-hidden" }
const _hoisted_98 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "px-6 py-4 border-b border-purple-800/50 bg-gradient-to-r from-purple-900/50 to-gray-900" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "text-lg font-heading font-semibold text-purple-400 flex items-center gap-2" }, [
    /*#__PURE__*/_createElementVNode("span", null, "📷"),
    /*#__PURE__*/_createTextVNode(" Best Photo Op ")
  ])
], -1))
const _hoisted_99 = { class: "divide-y divide-gray-800" }
const _hoisted_100 = { key: 0 }
const _hoisted_101 = { key: 1 }
const _hoisted_102 = { class: "flex-1 min-w-0" }
const _hoisted_103 = { class: "font-medium text-purple-300 truncate" }
const _hoisted_104 = { class: "text-sm text-gray-500 truncate" }
const _hoisted_105 = { class: "text-right" }
const _hoisted_106 = { class: "font-semibold text-purple-400" }
const _hoisted_107 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm text-gray-500 ml-1" }, "votes", -1))
const _hoisted_108 = {
  key: 0,
  class: "px-6 py-8 text-center text-gray-500"
}
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-3xl" }, "👻", -1))
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-2" }, "No spirits summoned yet...", -1))
const _hoisted_111 = [
  _hoisted_109,
  _hoisted_110
]
const _hoisted_112 = { key: 2 }
const _hoisted_113 = { class: "max-w-xl mx-auto" }
const _hoisted_114 = {
  key: 0,
  class: "bg-gray-900 rounded-xl border border-green-700/50 shadow-lg shadow-green-900/20 overflow-hidden text-center"
}
const _hoisted_115 = /*#__PURE__*/_createStaticVNode("<div class=\"bg-gradient-to-r from-green-800 to-green-700 py-8 relative\" data-v-7e67b94a><div class=\"absolute inset-0 flex items-center justify-center opacity-20\" data-v-7e67b94a><span class=\"text-9xl\" data-v-7e67b94a>🎃</span></div><div class=\"relative w-20 h-20 mx-auto bg-gray-900 rounded-full flex items-center justify-center border-4 border-green-400 shadow-lg shadow-green-500/50\" data-v-7e67b94a><span class=\"text-4xl\" data-v-7e67b94a>✓</span></div></div>", 1)
const _hoisted_116 = { class: "p-6 space-y-4" }
const _hoisted_117 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-2xl font-heading font-bold text-green-400" }, " 🏆 You're In the Contest! 🏆 ", -1))
const _hoisted_118 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-300" }, " Your haunted house is now competing! Check out the Spooky Map to see all participating houses. ", -1))
const _hoisted_119 = { class: "bg-gray-800 rounded-lg p-4 text-left space-y-2 border border-gray-700" }
const _hoisted_120 = { class: "text-sm text-gray-300" }
const _hoisted_121 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-medium text-orange-400" }, "Address:", -1))
const _hoisted_122 = {
  key: 0,
  class: "text-sm text-gray-300"
}
const _hoisted_123 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-medium text-orange-400" }, "House Name:", -1))
const _hoisted_124 = { class: "text-sm text-gray-300" }
const _hoisted_125 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "font-medium text-orange-400" }, "Contests:", -1))
const _hoisted_126 = {
  key: 0,
  class: "ml-1 px-2 py-0.5 bg-orange-900/50 text-orange-300 rounded text-xs border border-orange-700/50"
}
const _hoisted_127 = {
  key: 1,
  class: "ml-1 px-2 py-0.5 bg-purple-900/50 text-purple-300 rounded text-xs border border-purple-700/50"
}
const _hoisted_128 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bg-amber-900/30 border border-amber-700/50 rounded-lg p-4 text-left" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-amber-300" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "font-medium" }, "📷 Don't have a photo yet?"),
    /*#__PURE__*/_createTextVNode(" No problem! You can come back anytime before Halloween to add or update your photo. ")
  ])
], -1))
const _hoisted_129 = { class: "flex flex-col sm:flex-row gap-3 pt-2" }
const _hoisted_130 = {
  key: 1,
  class: "bg-gray-900 rounded-xl border border-purple-800/50 shadow-lg shadow-purple-900/20 overflow-hidden"
}
const _hoisted_131 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "px-6 py-4 border-b border-purple-800/50 bg-gradient-to-r from-purple-900/50 to-gray-900" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "text-lg font-heading font-semibold text-purple-400 flex items-center gap-2" }, [
    /*#__PURE__*/_createElementVNode("span", null, "🏆"),
    /*#__PURE__*/_createTextVNode(" Enter the Decoration Contest ")
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-400 mt-1" }, " Compete for Best Decorated House or Best Photo Op! ")
], -1))
const _hoisted_132 = {
  key: 0,
  class: "p-6 text-center"
}
const _hoisted_133 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-5xl animate-bounce" }, "👻", -1))
const _hoisted_134 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-2 text-gray-400" }, "Summoning your details...", -1))
const _hoisted_135 = [
  _hoisted_133,
  _hoisted_134
]
const _hoisted_136 = {
  key: 1,
  class: "p-6"
}
const _hoisted_137 = { class: "text-center text-gray-400" }
const _hoisted_138 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-4xl" }, "🏪", -1))
const _hoisted_139 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-2" }, "You need to have a house assigned to your account to register.", -1))
const _hoisted_140 = /*#__PURE__*/_createTextVNode(" Go to Profile → ")
const _hoisted_141 = ["onSubmit"]
const _hoisted_142 = {
  key: 0,
  class: "bg-green-900/30 border border-green-700/50 rounded-lg p-4 text-green-300"
}
const _hoisted_143 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "✓ You're registered!", -1))
const _hoisted_144 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-sm mt-1 text-green-400/80" }, " Update your registration below or cancel to withdraw. ", -1))
const _hoisted_145 = [
  _hoisted_143,
  _hoisted_144
]
const _hoisted_146 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "block text-sm font-medium text-gray-300 mb-2" }, " House Name (optional) ", -1))
const _hoisted_147 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-gray-500 mt-1" }, " Give your house a spooky name for the guide! ", -1))
const _hoisted_148 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "block text-sm font-medium text-gray-300 mb-2" }, " Photo of Your House ", -1))
const _hoisted_149 = {
  key: 0,
  class: "mb-3 relative"
}
const _hoisted_150 = ["src"]
const _hoisted_151 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "h-4 w-4",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M6 18L18 6M6 6l12 12"
  })
], -1))
const _hoisted_152 = [
  _hoisted_151
]
const _hoisted_153 = { class: "flex flex-col sm:flex-row gap-2" }
const _hoisted_154 = { class: "flex-1 cursor-pointer" }
const _hoisted_155 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-center gap-2 px-4 py-3 bg-gradient-to-r from-orange-600 to-orange-500 text-white rounded-lg font-medium hover:from-orange-500 hover:to-orange-400 active:from-orange-700 active:to-orange-600 transition-all shadow-lg shadow-orange-500/30" }, [
  /*#__PURE__*/_createElementVNode("span", null, "📷"),
  /*#__PURE__*/_createTextVNode(" Take Photo ")
], -1))
const _hoisted_156 = { class: "flex-1 cursor-pointer" }
const _hoisted_157 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex items-center justify-center gap-2 px-4 py-3 bg-gray-800 text-orange-400 border border-orange-700/50 rounded-lg font-medium hover:bg-gray-700 active:bg-gray-900 transition-colors" }, [
  /*#__PURE__*/_createElementVNode("span", null, "🖼"),
  /*#__PURE__*/_createTextVNode(" Choose from Library ")
], -1))
const _hoisted_158 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-gray-500 mt-2" }, " You can add a photo later if you don't have one yet! ", -1))
const _hoisted_159 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "block text-sm font-medium text-gray-300 mb-2" }, " Contests (select at least one) ", -1))
const _hoisted_160 = { class: "space-y-3" }
const _hoisted_161 = { class: "flex items-center gap-3 cursor-pointer p-3 rounded-lg border border-gray-700 hover:border-orange-500/50 transition-colors bg-gray-800/50" }
const _hoisted_162 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-orange-300 font-medium" }, "🎃 Best Decorated House"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-gray-500" }, "Show off your spooky decorations")
], -1))
const _hoisted_163 = { class: "flex items-center gap-3 cursor-pointer p-3 rounded-lg border border-gray-700 hover:border-purple-500/50 transition-colors bg-gray-800/50" }
const _hoisted_164 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-purple-300 font-medium" }, "📷 Best Photo Op"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-gray-500" }, "A great spot for trick-or-treat photos")
], -1))
const _hoisted_165 = {
  key: 1,
  class: "bg-red-900/30 border border-red-700/50 rounded-lg p-4 text-red-300 text-sm"
}
const _hoisted_166 = { class: "flex gap-3" }
const _hoisted_167 = ["disabled"]
const _hoisted_168 = ["disabled"]
const _hoisted_169 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-gray-500 text-center pt-2" }, " 👻 Not competing? No worries! All houses are welcome for trick-or-treating. ", -1))
const _hoisted_170 = {
  key: 2,
  class: "bg-gray-900 rounded-xl border border-purple-800/50 shadow-lg shadow-purple-900/20 overflow-hidden"
}
const _hoisted_171 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "px-6 py-4 border-b border-purple-800/50 bg-gradient-to-r from-purple-900/50 to-gray-900" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "text-lg font-heading font-semibold text-purple-400 flex items-center gap-2" }, [
    /*#__PURE__*/_createElementVNode("span", null, "🏆"),
    /*#__PURE__*/_createTextVNode(" Enter the Decoration Contest ")
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "text-sm text-gray-400 mt-1" }, " Compete for Best Decorated House or Best Photo Op! ")
], -1))
const _hoisted_172 = { class: "p-6 space-y-6" }
const _hoisted_173 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400" }, " Want to compete? Enter your address and email below. We'll match your address to our neighborhood records. ", -1))
const _hoisted_174 = ["onSubmit"]
const _hoisted_175 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "block text-sm font-medium text-gray-300 mb-2" }, " Your Address ", -1))
const _hoisted_176 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "block text-sm font-medium text-gray-300 mb-2" }, " Email Address ", -1))
const _hoisted_177 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-gray-500 mt-1" }, " We'll send confirmation and let you know how to add a photo ", -1))
const _hoisted_178 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "block text-sm font-medium text-gray-300 mb-2" }, " Contests (select at least one) ", -1))
const _hoisted_179 = { class: "space-y-3" }
const _hoisted_180 = { class: "flex items-center gap-3 cursor-pointer p-3 rounded-lg border border-gray-700 hover:border-orange-500/50 transition-colors bg-gray-800/50" }
const _hoisted_181 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-orange-300" }, "🎃 Best Decorated House", -1))
const _hoisted_182 = { class: "flex items-center gap-3 cursor-pointer p-3 rounded-lg border border-gray-700 hover:border-purple-500/50 transition-colors bg-gray-800/50" }
const _hoisted_183 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-purple-300" }, "📷 Best Photo Op", -1))
const _hoisted_184 = {
  key: 0,
  class: "bg-red-900/30 border border-red-700/50 rounded-lg p-4 text-red-300 text-sm"
}
const _hoisted_185 = {
  key: 1,
  class: "bg-green-900/30 border border-green-700/50 rounded-lg p-4 text-green-300"
}
const _hoisted_186 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "✓ Registration submitted!", -1))
const _hoisted_187 = { class: "text-sm mt-1 text-green-400/80" }
const _hoisted_188 = ["disabled"]
const _hoisted_189 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-xs text-gray-500 text-center pt-3" }, " 👻 Not competing? No worries! All houses are welcome for trick-or-treating. ", -1))
const _hoisted_190 = { class: "border-t border-gray-700 pt-4" }
const _hoisted_191 = { class: "text-sm text-gray-400 text-center" }
const _hoisted_192 = /*#__PURE__*/_createTextVNode(" Already have an account? ")
const _hoisted_193 = /*#__PURE__*/_createTextVNode(" Log in ")
const _hoisted_194 = /*#__PURE__*/_createTextVNode(" to manage your registration and add photos. ")
const _hoisted_195 = {
  key: 0,
  class: "fixed bottom-4 left-4 right-4 sm:left-auto sm:right-4 sm:max-w-sm bg-gradient-to-r from-green-700 to-green-600 text-white px-6 py-4 rounded-xl shadow-2xl shadow-green-900/50 flex items-center gap-3 border border-green-500/50"
}
const _hoisted_196 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-3xl animate-bounce" }, "👻", -1))
const _hoisted_197 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-medium" }, "Spirit Summoned!", -1))
const _hoisted_198 = { class: "text-sm text-green-200" }

import { ref, computed, watch, onMounted } from "vue";
import { HoodApi } from "@/services/HoodApi";
import { useAuthStore } from "@/stores/auth";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const auth = useAuthStore();
const isLoggedIn = computed(() => auth.quick_verify());
const hasHouse = computed(() => auth.user_details?.house?.id > 0);

// Voting period: Oct 29 - Nov 1 (2 days before through 1 day after Halloween)
const VOTING_START = new Date("2026-10-29T00:00:00");
const VOTING_END = new Date("2026-11-02T00:00:00");

const isVotingOpen = computed(() => {
  const now = new Date();
  return now >= VOTING_START && now < VOTING_END;
});

const votingOpensIn = computed(() => {
  const now = new Date();
  if (now >= VOTING_START) return null;
  const diff = VOTING_START.getTime() - now.getTime();
  const days = Math.ceil(diff / (1000 * 60 * 60 * 24));
  return days;
});

// Tab state
const activeTab = ref<"guide" | "leaderboard" | "register">("guide");

// Event data
const eventData = ref<HalloweenHomeResponse | null>(null);

// Guide
const guideFilter = ref<"decorated" | "photo_op" | undefined>(undefined);
const participants = ref<HalloweenParticipant[]>([]);
const loadingGuide = ref(false);

// Leaderboard
const leaderboard = ref<HalloweenLeaderboard>({
  best_decorated: [],
  photo_op: [],
});
const loadingLeaderboard = ref(false);

// Registration
const myRegistration = ref<HalloweenMyRegistration | null>(null);
const loadingRegistration = ref(false);
const submittingReg = ref(false);
const regError = ref("");
const photoPreview = ref<string | null>(null);
const showRegSuccess = ref(false);
const regForm = ref<{
  house_name: string;
  photo: File | null;
  best_decorated: boolean;
  photo_op: boolean;
}>({
  house_name: "",
  photo: null,
  best_decorated: false,
  photo_op: false,
});

// Quick registration (for non-logged-in users)
const quickReg = ref({
  address: "",
  email: "",
  best_decorated: false,
  photo_op: false,
});
const submittingQuickReg = ref(false);
const quickRegError = ref("");
const quickRegSuccess = ref("");

// Voting
const votingFor = ref<number | null>(null);
const voteSuccess = ref("");

// Format helpers
function formatDate(dateStr: string): string {
  const date = new Date(dateStr + "T00:00:00");
  return date.toLocaleDateString("en-US", {
    weekday: "long",
    month: "long",
    day: "numeric",
    year: "numeric",
  });
}

function formatTime(timeStr: string): string {
  const [hours, minutes] = timeStr.split(":");
  const date = new Date();
  date.setHours(parseInt(hours), parseInt(minutes));
  return date.toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "2-digit",
  });
}

// Load event data
async function loadEventData() {
  try {
    eventData.value = await HoodApi.fetch_halloween_home();
  } catch (error) {
    console.error("Failed to load event data:", error);
  }
}

// Load guide
async function loadGuide() {
  loadingGuide.value = true;
  try {
    const response = await HoodApi.fetch_halloween_guide(guideFilter.value);
    participants.value = response.participants;
  } catch (error) {
    console.error("Failed to load guide:", error);
  } finally {
    loadingGuide.value = false;
  }
}

// Load leaderboard
async function loadLeaderboard() {
  loadingLeaderboard.value = true;
  try {
    leaderboard.value = await HoodApi.fetch_halloween_leaderboard();
  } catch (error) {
    console.error("Failed to load leaderboard:", error);
  } finally {
    loadingLeaderboard.value = false;
  }
}

// Load registration
async function loadRegistration() {
  if (!isLoggedIn.value) return;
  loadingRegistration.value = true;
  try {
    // Ensure user data is loaded
    if (auth.user_details?.house?.id <= 0) {
      await auth.fetch_user_data();
    }
    myRegistration.value = await HoodApi.fetch_halloween_registration();
    if (myRegistration.value?.participant) {
      regForm.value.house_name = myRegistration.value.participant.house_name || "";
      regForm.value.best_decorated = myRegistration.value.participant.best_decorated;
      regForm.value.photo_op = myRegistration.value.participant.photo_op;
    }
  } catch (error) {
    console.error("Failed to load registration:", error);
  } finally {
    loadingRegistration.value = false;
  }
}

// Handle photo change
function handlePhotoChange(event: Event) {
  const input = event.target as HTMLInputElement;
  if (input.files && input.files[0]) {
    regForm.value.photo = input.files[0];
    // Create preview URL
    photoPreview.value = URL.createObjectURL(input.files[0]);
  }
}

// Clear photo selection
function clearPhoto() {
  regForm.value.photo = null;
  if (photoPreview.value) {
    URL.revokeObjectURL(photoPreview.value);
    photoPreview.value = null;
  }
}

// Submit registration
async function submitRegistration() {
  submittingReg.value = true;
  regError.value = "";
  const isNewRegistration = !myRegistration.value?.registered;
  try {
    await HoodApi.submit_halloween_registration({
      house_name: regForm.value.house_name || undefined,
      photo: regForm.value.photo || undefined,
      best_decorated: regForm.value.best_decorated,
      photo_op: regForm.value.photo_op,
    });
    await loadRegistration();
    await loadGuide();
    await loadEventData();
    // Show success screen for new registrations
    if (isNewRegistration) {
      showRegSuccess.value = true;
    }
  } catch (error: any) {
    regError.value =
      error.response?.data?.error ||
      error.response?.data?.detail ||
      "Failed to submit registration";
  } finally {
    submittingReg.value = false;
  }
}

// Submit quick registration (non-logged-in users)
async function submitQuickRegistration() {
  submittingQuickReg.value = true;
  quickRegError.value = "";
  quickRegSuccess.value = "";
  try {
    const response = await HoodApi.submit_halloween_quick_registration({
      address: quickReg.value.address,
      email: quickReg.value.email,
      best_decorated: quickReg.value.best_decorated,
      photo_op: quickReg.value.photo_op,
    });
    quickRegSuccess.value = response.message;
    // Clear form on success
    quickReg.value = {
      address: "",
      email: "",
      best_decorated: false,
      photo_op: false,
    };
    await loadGuide();
    await loadEventData();
  } catch (error: any) {
    quickRegError.value =
      error.response?.data?.error ||
      error.response?.data?.detail ||
      "Failed to submit registration. Please try again or contact us.";
  } finally {
    submittingQuickReg.value = false;
  }
}

// Cancel registration
async function cancelRegistration() {
  if (!confirm("Are you sure you want to cancel your registration?")) return;
  submittingReg.value = true;
  try {
    await HoodApi.cancel_halloween_registration();
    myRegistration.value = { registered: false, participant: null };
    regForm.value = {
      house_name: "",
      photo: null,
      best_decorated: false,
      photo_op: false,
    };
    await loadGuide();
    await loadEventData();
  } catch (error) {
    console.error("Failed to cancel registration:", error);
  } finally {
    submittingReg.value = false;
  }
}

// Vote
async function vote(participantId: number, contest: "decorated" | "photo_op") {
  votingFor.value = participantId;
  try {
    const response = await HoodApi.cast_halloween_vote(participantId, contest);
    voteSuccess.value = response.message;
    setTimeout(() => {
      voteSuccess.value = "";
    }, 3000);
    await loadLeaderboard();
    await loadEventData();
  } catch (error: any) {
    const message =
      error.response?.data?.error || "Failed to cast vote";
    alert(message);
  } finally {
    votingFor.value = null;
  }
}

// Watch tab changes
watch(activeTab, (tab) => {
  if (tab === "guide") loadGuide();
  if (tab === "leaderboard") loadLeaderboard();
  if (tab === "register") loadRegistration();
});

// Watch filter changes
watch(guideFilter, () => {
  loadGuide();
});

// Initial load
onMounted(() => {
  loadEventData();
  loadGuide();
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("h1", _hoisted_7, " 🎃 " + _toDisplayString(eventData.value?.event?.title || "Halloween Trick or Treat") + " 🎃 ", 1),
          _hoisted_8,
          (eventData.value?.event)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("span", _hoisted_10, [
                  _hoisted_11,
                  _createTextVNode(" " + _toDisplayString(formatDate(eventData.value.event.date)), 1)
                ]),
                _createElementVNode("span", _hoisted_12, [
                  _hoisted_13,
                  _createTextVNode(" " + _toDisplayString(formatTime(eventData.value.event.start_time)) + " - " + _toDisplayString(formatTime(eventData.value.event.end_time)), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (eventData.value?.stats)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, _toDisplayString(eventData.value.stats.total_participants), 1),
                  _hoisted_17
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, _toDisplayString(eventData.value.stats.total_votes), 1),
                  _hoisted_20
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (activeTab.value = 'register')),
              class: "inline-flex items-center gap-2 px-6 py-4 bg-orange-500 text-white rounded-lg font-bold text-lg hover:bg-orange-400 active:bg-orange-600 transition-all shadow-lg shadow-orange-500/30 hover:shadow-orange-500/50 hover:scale-105 transform"
            }, _hoisted_25),
            _hoisted_26
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_27, [
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("nav", _hoisted_29, [
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (activeTab.value = 'guide')),
            class: _normalizeClass(["flex-1 flex items-center justify-center gap-2 px-4 py-4 text-sm font-medium transition-colors relative", {
              'text-orange-400': activeTab.value === 'guide',
              'text-gray-400 hover:text-orange-300': activeTab.value !== 'guide',
            }])
          }, [
            _hoisted_30,
            _hoisted_31,
            (activeTab.value === 'guide')
              ? (_openBlock(), _createElementBlock("span", _hoisted_32))
              : _createCommentVNode("", true)
          ], 2),
          (_unref(isVotingOpen))
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: _cache[2] || (_cache[2] = ($event: any) => (activeTab.value = 'leaderboard')),
                class: _normalizeClass(["flex-1 flex items-center justify-center gap-2 px-4 py-4 text-sm font-medium transition-colors relative", {
              'text-green-400': activeTab.value === 'leaderboard',
              'text-gray-400 hover:text-green-300':
                activeTab.value !== 'leaderboard',
            }])
              }, [
                _hoisted_33,
                _hoisted_34,
                (activeTab.value === 'leaderboard')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_35))
                  : _createCommentVNode("", true)
              ], 2))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (activeTab.value = 'register')),
            class: _normalizeClass(["flex-1 flex items-center justify-center gap-2 px-4 py-4 text-sm font-medium transition-colors relative", {
              'text-purple-400': activeTab.value === 'register',
              'text-gray-400 hover:text-purple-300':
                activeTab.value !== 'register',
            }])
          }, [
            _hoisted_36,
            _hoisted_37,
            (activeTab.value === 'register')
              ? (_openBlock(), _createElementBlock("span", _hoisted_38))
              : _createCommentVNode("", true)
          ], 2)
        ])
      ]),
      (activeTab.value === 'guide')
        ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
            _hoisted_40,
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("button", {
                onClick: _cache[4] || (_cache[4] = ($event: any) => (guideFilter.value = undefined)),
                class: _normalizeClass(["px-4 py-2 rounded-full text-sm font-medium transition-all", {
              'bg-orange-500 text-white shadow-lg shadow-orange-500/30': guideFilter.value === undefined,
              'bg-gray-800 text-gray-300 border border-gray-700 hover:border-orange-500 hover:text-orange-400':
                guideFilter.value !== undefined,
            }])
              }, " 👻 All Haunts ", 2),
              _createElementVNode("button", {
                onClick: _cache[5] || (_cache[5] = ($event: any) => (guideFilter.value = 'decorated')),
                class: _normalizeClass(["px-4 py-2 rounded-full text-sm font-medium transition-all", {
              'bg-orange-500 text-white shadow-lg shadow-orange-500/30': guideFilter.value === 'decorated',
              'bg-gray-800 text-gray-300 border border-gray-700 hover:border-orange-500 hover:text-orange-400':
                guideFilter.value !== 'decorated',
            }])
              }, " 🎃 Best Decorated ", 2),
              _createElementVNode("button", {
                onClick: _cache[6] || (_cache[6] = ($event: any) => (guideFilter.value = 'photo_op')),
                class: _normalizeClass(["px-4 py-2 rounded-full text-sm font-medium transition-all", {
              'bg-purple-500 text-white shadow-lg shadow-purple-500/30': guideFilter.value === 'photo_op',
              'bg-gray-800 text-gray-300 border border-gray-700 hover:border-purple-500 hover:text-purple-400':
                guideFilter.value !== 'photo_op',
            }])
              }, " 📷 Best Photo Op ", 2)
            ]),
            (loadingGuide.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_42, _hoisted_45))
              : (participants.value.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                    _hoisted_47,
                    _hoisted_48,
                    _hoisted_49,
                    _createElementVNode("button", {
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (activeTab.value = 'register')),
                      class: "mt-4 inline-flex items-center gap-2 px-4 py-2 bg-orange-600 text-white rounded-lg font-medium hover:bg-orange-500 transition-colors"
                    }, _hoisted_52)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_53, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(participants.value, (participant) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: participant.id,
                        class: "bg-gray-900 rounded-xl border border-gray-800 shadow-lg overflow-hidden hover:border-orange-500/50 transition-all hover:shadow-orange-500/10 group"
                      }, [
                        _createElementVNode("div", _hoisted_54, [
                          (participant.photo_url)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: participant.photo_url,
                                alt: participant.house_name || participant.address,
                                class: "w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                              }, null, 8, _hoisted_55))
                            : (_openBlock(), _createElementBlock("div", _hoisted_56, _hoisted_58)),
                          _createElementVNode("div", _hoisted_59, [
                            (participant.best_decorated)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_60, " 🎃 Decorated "))
                              : _createCommentVNode("", true),
                            (participant.photo_op)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_61, " 📷 Photo Op "))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_62, [
                          _createElementVNode("h3", _hoisted_63, _toDisplayString(participant.house_name || participant.address), 1),
                          (participant.house_name)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_64, _toDisplayString(participant.address), 1))
                            : _createCommentVNode("", true),
                          (_unref(isVotingOpen))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                                (participant.best_decorated)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      onClick: ($event: any) => (vote(participant.id, 'decorated')),
                                      disabled: votingFor.value === participant.id,
                                      class: "flex-1 flex items-center justify-center gap-2 px-4 py-3 rounded-lg text-base font-medium transition-all bg-gradient-to-r from-orange-600 to-orange-500 text-white hover:from-orange-500 hover:to-orange-400 active:from-orange-700 active:to-orange-600 disabled:opacity-50 shadow-lg shadow-orange-500/30 hover:shadow-orange-500/50 hover:scale-105 transform"
                                    }, _hoisted_69, 8, _hoisted_66))
                                  : _createCommentVNode("", true),
                                (participant.photo_op)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 1,
                                      onClick: ($event: any) => (vote(participant.id, 'photo_op')),
                                      disabled: votingFor.value === participant.id,
                                      class: "flex-1 flex items-center justify-center gap-2 px-4 py-3 rounded-lg text-base font-medium transition-all bg-gradient-to-r from-purple-600 to-purple-500 text-white hover:from-purple-500 hover:to-purple-400 active:from-purple-700 active:to-purple-600 disabled:opacity-50 shadow-lg shadow-purple-500/30 hover:shadow-purple-500/50 hover:scale-105 transform"
                                    }, _hoisted_73, 8, _hoisted_70))
                                  : _createCommentVNode("", true)
                              ]))
                            : (_unref(votingOpensIn))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                                  _hoisted_75,
                                  _createTextVNode(" Voting opens in " + _toDisplayString(_unref(votingOpensIn)) + " day" + _toDisplayString(_unref(votingOpensIn) > 1 ? 's' : ''), 1)
                                ]))
                              : _createCommentVNode("", true)
                        ])
                      ]))
                    }), 128))
                  ]))
          ]))
        : _createCommentVNode("", true),
      (activeTab.value === 'leaderboard')
        ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
            (loadingLeaderboard.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_77, _hoisted_80))
              : (_openBlock(), _createElementBlock("div", _hoisted_81, [
                  _createElementVNode("div", _hoisted_82, [
                    _hoisted_83,
                    _createElementVNode("div", _hoisted_84, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(leaderboard.value.best_decorated, (entry, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: entry.id,
                          class: "px-6 py-3 flex items-center gap-4 hover:bg-gray-800/50 transition-colors"
                        }, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["w-8 h-8 rounded-full flex items-center justify-center font-bold text-sm", {
                    'bg-yellow-500 text-yellow-900 shadow-lg shadow-yellow-500/50': index === 0,
                    'bg-gray-400 text-gray-900': index === 1,
                    'bg-orange-600 text-white': index === 2,
                    'bg-gray-700 text-gray-300': index > 2,
                  }])
                          }, [
                            (index === 0)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_85, "👑"))
                              : (_openBlock(), _createElementBlock("span", _hoisted_86, _toDisplayString(index + 1), 1))
                          ], 2),
                          _createElementVNode("div", _hoisted_87, [
                            _createElementVNode("p", _hoisted_88, _toDisplayString(entry.name), 1),
                            _createElementVNode("p", _hoisted_89, _toDisplayString(entry.address), 1)
                          ]),
                          _createElementVNode("div", _hoisted_90, [
                            _createElementVNode("span", _hoisted_91, _toDisplayString(entry.votes), 1),
                            _hoisted_92
                          ])
                        ]))
                      }), 128)),
                      (leaderboard.value.best_decorated.length === 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_93, _hoisted_96))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_97, [
                    _hoisted_98,
                    _createElementVNode("div", _hoisted_99, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(leaderboard.value.photo_op, (entry, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: entry.id,
                          class: "px-6 py-3 flex items-center gap-4 hover:bg-gray-800/50 transition-colors"
                        }, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["w-8 h-8 rounded-full flex items-center justify-center font-bold text-sm", {
                    'bg-yellow-500 text-yellow-900 shadow-lg shadow-yellow-500/50': index === 0,
                    'bg-gray-400 text-gray-900': index === 1,
                    'bg-purple-600 text-white': index === 2,
                    'bg-gray-700 text-gray-300': index > 2,
                  }])
                          }, [
                            (index === 0)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_100, "👑"))
                              : (_openBlock(), _createElementBlock("span", _hoisted_101, _toDisplayString(index + 1), 1))
                          ], 2),
                          _createElementVNode("div", _hoisted_102, [
                            _createElementVNode("p", _hoisted_103, _toDisplayString(entry.name), 1),
                            _createElementVNode("p", _hoisted_104, _toDisplayString(entry.address), 1)
                          ]),
                          _createElementVNode("div", _hoisted_105, [
                            _createElementVNode("span", _hoisted_106, _toDisplayString(entry.votes), 1),
                            _hoisted_107
                          ])
                        ]))
                      }), 128)),
                      (leaderboard.value.photo_op.length === 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_108, _hoisted_111))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
          ]))
        : _createCommentVNode("", true),
      (activeTab.value === 'register')
        ? (_openBlock(), _createElementBlock("div", _hoisted_112, [
            _createElementVNode("div", _hoisted_113, [
              (showRegSuccess.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_114, [
                    _hoisted_115,
                    _createElementVNode("div", _hoisted_116, [
                      _hoisted_117,
                      _hoisted_118,
                      _createElementVNode("div", _hoisted_119, [
                        _createElementVNode("p", _hoisted_120, [
                          _hoisted_121,
                          _createTextVNode(" " + _toDisplayString(_unref(auth).user_details?.house?.house_number) + " " + _toDisplayString(_unref(auth).user_details?.house?.street), 1)
                        ]),
                        (regForm.value.house_name)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_122, [
                              _hoisted_123,
                              _createTextVNode(" " + _toDisplayString(regForm.value.house_name), 1)
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("p", _hoisted_124, [
                          _hoisted_125,
                          (regForm.value.best_decorated)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_126, "🎃 Best Decorated"))
                            : _createCommentVNode("", true),
                          (regForm.value.photo_op)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_127, "📷 Photo Op"))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _hoisted_128,
                      _createElementVNode("div", _hoisted_129, [
                        _createElementVNode("button", {
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (showRegSuccess.value = false)),
                          class: "flex-1 px-4 py-3 bg-gradient-to-r from-orange-600 to-orange-500 text-white rounded-lg font-medium hover:from-orange-500 hover:to-orange-400 transition-all shadow-lg shadow-orange-500/30"
                        }, " ✎ Update Registration "),
                        _createElementVNode("button", {
                          onClick: _cache[9] || (_cache[9] = ($event: any) => (activeTab.value = 'guide')),
                          class: "flex-1 px-4 py-3 border border-gray-600 text-gray-300 rounded-lg font-medium hover:bg-gray-800 transition-colors"
                        }, " 🗺 View All Houses ")
                      ])
                    ])
                  ]))
                : (_unref(isLoggedIn))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_130, [
                      _hoisted_131,
                      (loadingRegistration.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_132, _hoisted_135))
                        : (!_unref(hasHouse))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_136, [
                              _createElementVNode("div", _hoisted_137, [
                                _hoisted_138,
                                _hoisted_139,
                                _createVNode(_component_router_link, {
                                  to: "/profile",
                                  class: "inline-block mt-4 text-orange-400 hover:text-orange-300 font-medium"
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_140
                                  ]),
                                  _: 1
                                })
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock("form", {
                              key: 2,
                              onSubmit: _withModifiers(submitRegistration, ["prevent"]),
                              class: "p-6 space-y-6"
                            }, [
                              (myRegistration.value?.registered)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_142, _hoisted_145))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", null, [
                                _hoisted_146,
                                _withDirectives(_createElementVNode("input", {
                                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((regForm.value.house_name) = $event)),
                                  type: "text",
                                  placeholder: "e.g., \"The Shrieking Shack\"",
                                  class: "w-full px-4 py-3 bg-gray-800 border border-gray-700 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 text-base text-white placeholder-gray-500"
                                }, null, 512), [
                                  [_vModelText, regForm.value.house_name]
                                ]),
                                _hoisted_147
                              ]),
                              _createElementVNode("div", null, [
                                _hoisted_148,
                                (photoPreview.value || myRegistration.value?.participant?.photo_url)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_149, [
                                      _createElementVNode("img", {
                                        src: photoPreview.value || myRegistration.value?.participant?.photo_url,
                                        alt: "House photo",
                                        class: "w-full h-48 object-cover rounded-lg border border-gray-700"
                                      }, null, 8, _hoisted_150),
                                      (photoPreview.value)
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 0,
                                            type: "button",
                                            onClick: clearPhoto,
                                            class: "absolute top-2 right-2 bg-red-600 text-white p-1.5 rounded-full shadow-lg hover:bg-red-500"
                                          }, _hoisted_152))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_153, [
                                  _createElementVNode("label", _hoisted_154, [
                                    _createElementVNode("input", {
                                      type: "file",
                                      accept: "image/*",
                                      capture: "environment",
                                      onChange: handlePhotoChange,
                                      class: "hidden"
                                    }, null, 32),
                                    _hoisted_155
                                  ]),
                                  _createElementVNode("label", _hoisted_156, [
                                    _createElementVNode("input", {
                                      type: "file",
                                      accept: "image/*",
                                      onChange: handlePhotoChange,
                                      class: "hidden"
                                    }, null, 32),
                                    _hoisted_157
                                  ])
                                ]),
                                _hoisted_158
                              ]),
                              _createElementVNode("div", null, [
                                _hoisted_159,
                                _createElementVNode("div", _hoisted_160, [
                                  _createElementVNode("label", _hoisted_161, [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "checkbox",
                                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((regForm.value.best_decorated) = $event)),
                                      class: "w-5 h-5 rounded border-gray-600 bg-gray-700 text-orange-600 focus:ring-orange-500 focus:ring-offset-gray-900"
                                    }, null, 512), [
                                      [_vModelCheckbox, regForm.value.best_decorated]
                                    ]),
                                    _hoisted_162
                                  ]),
                                  _createElementVNode("label", _hoisted_163, [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "checkbox",
                                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((regForm.value.photo_op) = $event)),
                                      class: "w-5 h-5 rounded border-gray-600 bg-gray-700 text-purple-600 focus:ring-purple-500 focus:ring-offset-gray-900"
                                    }, null, 512), [
                                      [_vModelCheckbox, regForm.value.photo_op]
                                    ]),
                                    _hoisted_164
                                  ])
                                ])
                              ]),
                              (regError.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_165, _toDisplayString(regError.value), 1))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_166, [
                                _createElementVNode("button", {
                                  type: "submit",
                                  disabled: submittingReg.value || (!regForm.value.best_decorated && !regForm.value.photo_op),
                                  class: "flex-1 bg-gradient-to-r from-orange-600 to-orange-500 text-white px-4 py-3 rounded-lg font-medium hover:from-orange-500 hover:to-orange-400 transition-all disabled:opacity-50 disabled:cursor-not-allowed text-base shadow-lg shadow-orange-500/30"
                                }, _toDisplayString(submittingReg.value ? "Summoning..." : myRegistration.value?.registered ? "✎ Update Entry" : "🏆 Enter Contest"), 9, _hoisted_167),
                                (myRegistration.value?.registered)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      type: "button",
                                      onClick: cancelRegistration,
                                      disabled: submittingReg.value,
                                      class: "px-4 py-3 rounded-lg font-medium border border-red-700/50 text-red-400 hover:bg-red-900/30 transition-colors disabled:opacity-50"
                                    }, " Withdraw ", 8, _hoisted_168))
                                  : _createCommentVNode("", true)
                              ]),
                              _hoisted_169
                            ], 40, _hoisted_141))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_170, [
                      _hoisted_171,
                      _createElementVNode("div", _hoisted_172, [
                        _hoisted_173,
                        _createElementVNode("form", {
                          onSubmit: _withModifiers(submitQuickRegistration, ["prevent"]),
                          class: "space-y-4"
                        }, [
                          _createElementVNode("div", null, [
                            _hoisted_175,
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((quickReg.value.address) = $event)),
                              type: "text",
                              placeholder: "e.g., 123 Elm St",
                              required: "",
                              class: "w-full px-4 py-3 bg-gray-800 border border-gray-700 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 text-base text-white placeholder-gray-500"
                            }, null, 512), [
                              [_vModelText, quickReg.value.address]
                            ])
                          ]),
                          _createElementVNode("div", null, [
                            _hoisted_176,
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((quickReg.value.email) = $event)),
                              type: "email",
                              placeholder: "your@email.com",
                              required: "",
                              class: "w-full px-4 py-3 bg-gray-800 border border-gray-700 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 text-base text-white placeholder-gray-500"
                            }, null, 512), [
                              [_vModelText, quickReg.value.email]
                            ]),
                            _hoisted_177
                          ]),
                          _createElementVNode("div", null, [
                            _hoisted_178,
                            _createElementVNode("div", _hoisted_179, [
                              _createElementVNode("label", _hoisted_180, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "checkbox",
                                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((quickReg.value.best_decorated) = $event)),
                                  class: "w-5 h-5 rounded border-gray-600 bg-gray-700 text-orange-600 focus:ring-orange-500 focus:ring-offset-gray-900"
                                }, null, 512), [
                                  [_vModelCheckbox, quickReg.value.best_decorated]
                                ]),
                                _hoisted_181
                              ]),
                              _createElementVNode("label", _hoisted_182, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "checkbox",
                                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((quickReg.value.photo_op) = $event)),
                                  class: "w-5 h-5 rounded border-gray-600 bg-gray-700 text-purple-600 focus:ring-purple-500 focus:ring-offset-gray-900"
                                }, null, 512), [
                                  [_vModelCheckbox, quickReg.value.photo_op]
                                ]),
                                _hoisted_183
                              ])
                            ])
                          ]),
                          (quickRegError.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_184, _toDisplayString(quickRegError.value), 1))
                            : _createCommentVNode("", true),
                          (quickRegSuccess.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_185, [
                                _hoisted_186,
                                _createElementVNode("p", _hoisted_187, _toDisplayString(quickRegSuccess.value), 1)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("button", {
                            type: "submit",
                            disabled: submittingQuickReg.value || (!quickReg.value.best_decorated && !quickReg.value.photo_op),
                            class: "w-full bg-gradient-to-r from-orange-600 to-orange-500 text-white px-4 py-3 rounded-lg font-medium hover:from-orange-500 hover:to-orange-400 transition-all disabled:opacity-50 disabled:cursor-not-allowed text-base shadow-lg shadow-orange-500/30"
                          }, _toDisplayString(submittingQuickReg.value ? "Summoning..." : "🏆 Enter Contest"), 9, _hoisted_188),
                          _hoisted_189
                        ], 40, _hoisted_174),
                        _createElementVNode("div", _hoisted_190, [
                          _createElementVNode("p", _hoisted_191, [
                            _hoisted_192,
                            _createVNode(_component_router_link, {
                              to: "/login",
                              class: "text-orange-400 hover:text-orange-300 font-medium"
                            }, {
                              default: _withCtx(() => [
                                _hoisted_193
                              ]),
                              _: 1
                            }),
                            _hoisted_194
                          ])
                        ])
                      ])
                    ]))
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_Transition, { name: "toast" }, {
      default: _withCtx(() => [
        (voteSuccess.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_195, [
              _hoisted_196,
              _createElementVNode("div", null, [
                _hoisted_197,
                _createElementVNode("p", _hoisted_198, _toDisplayString(voteSuccess.value), 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})